import { render, staticRenderFns } from "./zhenliaojilu.vue?vue&type=template&id=d8f7870a&scoped=true&"
import script from "./zhenliaojilu.vue?vue&type=script&lang=ts&"
export * from "./zhenliaojilu.vue?vue&type=script&lang=ts&"
import style0 from "./zhenliaojilu.vue?vue&type=style&index=0&id=d8f7870a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f7870a",
  null
  
)

export default component.exports